import { sendGoal } from '@/helpers/ymLogger'

export type MultichatEntrySource = 'topbar' | 'project_card' | 'tab' | 'popup' | 'promo'
export type MultichatExitTarget = 'marketplace' | 'tariffs' | 'project' | 'other'

// Идентификаторы целей заводятся руками в интерфейсе Метрики («JavaScript-событие»),
// поэтому они перечислены явно, а не собираются конкатенацией — так их видно грепом.
const ENTRY_GOALS: Record<MultichatEntrySource, string> = {
    topbar: 'multichat_open_topbar',
    project_card: 'multichat_open_project_card',
    tab: 'multichat_open_tab',
    popup: 'multichat_open_popup',
    promo: 'multichat_open_promo',
}

const EXIT_GOALS: Record<MultichatExitTarget, string> = {
    marketplace: 'multichat_exit_marketplace',
    tariffs: 'multichat_exit_tariffs',
    project: 'multichat_exit_project',
    other: 'multichat_exit_other',
}

export type MultichatGoal =
    | 'multichat_channel_connect_start'
    | 'multichat_channel_qr_shown'
    | 'multichat_channel_connected'
    | 'multichat_max_setup_open'
    | 'multichat_max_connected'
    | 'multichat_buy_multichat'
    | 'multichat_buy_max_business'
    | 'multichat_buy_extra_channel'
    | 'multichat_subscriptions_open'
    | 'multichat_gift_open'
    | 'multichat_promo_activate'
    | 'multichat_dismiss'

const PROJECT_MAIN_PATH = /^\/project\/[^/]+\/?$/
const TARIFF_PATH = /^\/project\/[^/]+\/(billing|finances|payment)(\/|$)/

function stripQuery(path: string): string {
    return path.split('?')[0].split('#')[0]
}

export function isChatSectionPath(fullPath: string): boolean {
    return /[?&]section=chat(?:&|$)/.test(fullPath || '')
}

export function classifyMultichatExit(path: string): MultichatExitTarget {
    const clean = stripQuery(path || '')
    if (clean.includes('/marketplace')) return 'marketplace'
    if (TARIFF_PATH.test(clean)) return 'tariffs'
    if (PROJECT_MAIN_PATH.test(clean)) return 'project'
    return 'other'
}

export function trackMultichatOpen(source: MultichatEntrySource) {
    void sendGoal(ENTRY_GOALS[source], { source })
}

export function trackMultichatExit(path: string) {
    const target = classifyMultichatExit(path)
    void sendGoal(EXIT_GOALS[target], { target, path: stripQuery(path || '') })
}

export function trackMultichatGoal(goal: MultichatGoal, payload: Record<string, any> = {}) {
    void sendGoal(goal, payload)
}

// Мелкие элементы интерфейса живут под одной зонтичной целью: заводить под каждую
// галочку отдельную цель в Метрике дорого, а разрез нужен только в отчёте по параметрам.
export function trackMultichatUiClick(button: string, payload: Record<string, any> = {}) {
    void sendGoal('multichat_ui_click', { button, ...payload })
}

export function trackMultichatViewChange(view: string, from: string | null) {
    void sendGoal('multichat_view_change', { view, from })
}
